var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "header" }, [
    _c("div", { staticClass: "container" }, [
      _c("img", {
        staticClass: "titleimg",
        attrs: {
          src:
            "https://img.yilieyun.cn/tenant-logo/48/2023/companyLogo_1204112135.png"
        }
      }),
      _vm._v(" "),
      _c("img", {
        staticClass: "menuicon",
        attrs: { src: _vm.img },
        on: { click: _vm.openmenu }
      })
    ]),
    _vm._v(" "),
    _vm.flagmenu
      ? _c("div", { staticClass: "menulist" }, [
          _c(
            "ul",
            _vm._l(_vm.menulist, function(item, index) {
              return _c(
                "li",
                {
                  key: index,
                  staticClass: "menuchild",
                  class: { pro: index == 1 },
                  on: {
                    click: function($event) {
                      return _vm.gotoclick(item.path)
                    }
                  }
                },
                [
                  _c("span", [_vm._v(_vm._s(item.name))]),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: index == 1,
                          expression: "index==1"
                        }
                      ],
                      staticClass: "probox",
                      on: {
                        click: function($event) {
                          return _vm.gotohandclick("1")
                        }
                      }
                    },
                    [
                      _vm._v(
                        "\n                   RPO招聘管理系统\n                "
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: index == 1,
                          expression: "index==1"
                        }
                      ],
                      staticClass: "probox",
                      on: {
                        click: function($event) {
                          return _vm.gotohandclick("2")
                        }
                      }
                    },
                    [
                      _vm._v(
                        "\n                   外包管理系统\n                "
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: index == 1,
                          expression: "index==1"
                        }
                      ],
                      staticClass: "probox",
                      on: {
                        click: function($event) {
                          return _vm.gotohandclick("3")
                        }
                      }
                    },
                    [
                      _vm._v(
                        "\n                   HR招聘管理系统\n                "
                      )
                    ]
                  )
                ]
              )
            }),
            0
          )
        ])
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-38a67261", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-38a67261","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/header/index.vue
// module id = null
// module chunks = 